<template>
    <div class="user-group-user-table action-table">
        <v-client-table
            :data="tableData"
            :columns="columns"
            :options="options"
            ref="table"
        >
            <colored-letter-square
                slot="cls_column"
                slot-scope="props"
                :name="props.row.full_name"
                :length="2"
            >
            </colored-letter-square>

            <div slot="actions" slot-scope="props">
                <UserGroupUsersTableActions
                    :user-group="userGroup"
                    :client="client"
                    :data="props.row"
                    :index="props.index"
                ></UserGroupUsersTableActions>
            </div>
        </v-client-table>
    </div>
</template>

<script>
import { EventBus } from '../eventbus';
import { Event } from 'vue-tables-2';

export default {
    props: [
        'client',
        'userGroup',
    ],

    data() {
        return {
            tableData: [],
            columns: ['cls_column', 'full_name', 'role_trans', 'email', 'actions'],
            options: {
                headings: {
                    cls_column: '',
                    full_name: this.trans('user_groups.label.full_name'),
                    role_trans: this.trans('users.label.role'),
                    email: this.trans('users.label.email'),
                    actions: this.trans('vuetables.label.actions'),
                },

                texts: {
                    count: this.trans('vuetables.label.countText'),
                    filter: this.trans('vuetables.label.filter'),
                    noResults: this.trans('vuetables.label.loading'),
                    filterPlaceholder: this.trans('vuetables.label.search')
                },

                sortable: ['full_name', 'client'],
            }
        };
    },

    created() {
        this.fetch();
    },

    methods: {
        fetch() {
            axios.get(this.route('tenantapi.clients.user-groups.users.index', {'client': this.client.id, 'user_group': this.userGroup.id}))
                 .then(this.refresh);
        },

        refresh({ data }) {
            // fetch the data
            this.tableData = data.data;

            // change the error text from 'now loding' to 'no match'
            this.options.texts.noResults = this.trans(
                'vuetables.label.noResults'
            );
        },
    },

    mounted() {
        EventBus.$on('onDelete', (deleteId) => {
            var index = this.tableData.findIndex(data => data.id == deleteId);
            this.tableData.splice(index, 1);
        });

        var filter = this.debounce((query) => {
            this.$refs.table.setFilter(query);
        }, 500);

        EventBus.$on('onFilter', query => {
            filter(query);
        });
    }
};
</script>
